module.exports = __webpack_public_path__ + "static/media/emotion_thankful.cd33b342.svg";